<template>
    <validation-observer v-slot="{ handleSubmit }" ref="formHandler">
        <form class="form tw-relative" @submit.prevent="handleSubmit(formSubmit)" novalidate>
<!--            <div class="tw-text-center tw-flex tw-flex-col tw-items-center tw-justify-center" v-show="formStep <= 2 && formError !== true">-->
<!--                <h2 class="tw-pt-8 tw-pb-6 lg:tw-pt-12">Solicite mais<br class="mobile"> informações sem<br class="desktop"> compromisso!</h2>-->
<!--            </div>-->
            <fieldset v-if="formStep == 1 && formError !== true" class="tw-px-3 lg:tw-px-0 tw-pb-5 lg:tw-pb-3">
                <div class="input-group">
                    <input type="hidden" class="form-control custom-select tw-pr-8"
                            @change="redirectToCourse"
                            v-model="selectedCourse" />
                </div>
                <validation-provider class="tw-w-full tw-w-block" rules="required|alpha_spaces" v-slot="{ classes }">
                    <div class="input-group input-group-name" :class="classes">
                        <input type="text"
                            placeholder=" "
                            v-model="name"
                        >
                        <label>
                            Nome e Apelido
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" rules="required|phone:pt" v-slot="{ classes }">
                    <div class="input-group input-group-phone" :class="classes">
                        <input type="tel"
                            placeholder=" "
                            v-model="phone"
                            v-mask="'#########'"
                        >
                        <label>
                            Telefone
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" rules="required|email" v-slot="{ classes }">
                    <div class="input-group input-group-email" :class="classes">
                        <input type="email"
                            placeholder=" "
                            v-model.lazy="email"
                        >
                        <label>
                            Email
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" :rules="{required : { allowFalse: false } }" v-slot="{ classes }">
                    <div class="mb-2">
                        <div class="form-check p-0">
                            <label class="form-check-label" :class="classes">
                                <input class="form-check-input" type="checkbox" value="true" v-model="$store.state.privacyPolicy">
                                <span class="checkmark"></span>
                                <span class="tw-text-white">Autorizo a MasterD a utilizar os meus dados para ser contactado segundo a sua <a href="#" @click.prevent="$store.state.modal.terms = true"><u>política de privacidade</u></a>.</span>
                            </label>
                        </div>
                    </div>
                </validation-provider>
                <div class="tw-text-center tw-mt-4">
                    <button
                        type="submit"
                        class="btn-cta"
                    >
                        Solicitar Informação
                    </button>
                </div>
            </fieldset>
            <fieldset v-if="formStep == 2 && formError !== true" class="tw-px-3 tw-pb-5 lg:tw-px-0 lg:tw-pb-3">
                <validation-provider class="tw-w-full tw-w-block" rules="required" v-slot="{ classes }">
                    <div class="input-group input-group-name" :class="classes">
                        <input type="tel"
                            placeholder=" "
                            v-mask="'##'"
                            v-model="age"
                        >
                        <label>
                            Idade
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" rules="required" v-slot="{ classes }">
                    <div class="input-group input-group-district" :class="classes">
                        <select
                            class="form-control custom-select"
                            v-model="district"
                            @change="getCities(); citiesList=[]; city=''; zipsList=[]; zip=''"
                        >
                            <option disabled value="">Distrito</option>
                            <option v-for="district in districtList" :key="district[0]" :value="district[0]">{{ district[1] }}</option>
                        </select>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" rules="required" v-slot="{ classes, errors }" v-if="citiesList.length != 0" key="city-input">
                    <div class="input-group input-group-district tw-relative" :class="classes">
                        <label class="error-label tw-absolute tw-hidden" style="font-size: 10px; color: red; padding-left: 52.5px; padding-top: 1px;">Não temos cursos na sua zona geográfica</label>
                        <select
                            class="form-control custom-select"
                            v-model="city"
                            @change="getZips(); zipsList = []; zip=''"
                        >
                            <option disabled value="">Cidade</option>
                            <option v-for="city in citiesList" :key="city[0]" :value="city[0]">{{ city[1] }}</option>
                        </select>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" rules="required" v-slot="{ classes }" vid="zip" v-if="zipsList.length != 0" key="zip-input">
                    <div class="input-group input-group-district" :class="classes">
                        <select
                            class="form-control custom-select"
                            v-model="zip"
                        >
                            <option disabled value="">Código Postal</option>
                            <option v-for="postalCode in zipsList" :key="postalCode[0]" :value="postalCode[0]">{{ postalCode[1] }}</option>
                        </select>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" rules="required" v-slot="{ classes }" vid="nationality" key="nationality-input">
                    <div class="input-group input-group-nationality" :class="classes">
                        <select
                            class="form-control custom-select"
                            v-model="nationality"
                        >
                            <option disabled value="">Nacionalidade</option>
                            <option value="203">PORTUGAL</option>
                            <option value="28">Afeganistão</option>
                            <option value="264">África do Sul</option>
                            <option value="31">Albânia</option>
                            <option value="79">Alemanha</option>
                            <option value="26">Andorra</option>
                            <option value="34">Angola</option>
                            <option value="30">Anguila</option>
                            <option value="35">Antártida</option>
                            <option value="29">Antigua e Barbuda</option>
                            <option value="33">Antilhas Holandesas</option>
                            <option value="211">Arabia Saudita</option>
                            <option value="84">Argélia</option>
                            <option value="36">Argentina</option>
                            <option value="32">Arménia</option>
                            <option value="40">Aruba</option>
                            <option value="39">Austrália</option>
                            <option value="38">Austria</option>
                            <option value="41">Azerbeijão</option>
                            <option value="55">Bahamas</option>
                            <option value="48">Bahrein</option>
                            <option value="44">Bangladesh</option>
                            <option value="43">Barbados</option>
                            <option value="45">Bélgica</option>
                            <option value="60">Belize</option>
                            <option value="50">Benín</option>
                            <option value="51">Bermudas</option>
                            <option value="59">Bielorrusia</option>
                            <option value="53">Bolívia</option>
                            <option value="42">Bósnia e Herzegovina</option>
                            <option value="58">Botsuana</option>
                            <option value="54">Brasil</option>
                            <option value="52">Brunei</option>
                            <option value="47">Bulgária</option>
                            <option value="46">Burkina Faso</option>
                            <option value="49">Burundi</option>
                            <option value="56">Butão</option>
                            <option value="75">Cabo Verde</option>
                            <option value="70">Camarões</option>
                            <option value="137">Cambodja</option>
                            <option value="61">Canadá</option>
                            <option value="145">Cazaquistão</option>
                            <option value="231">Chade</option>
                            <option value="69">Chile</option>
                            <option value="71">China</option>
                            <option value="77">Chipre</option>
                            <option value="72">Colômbia</option>
                            <option value="139">Comores</option>
                            <option value="65">Congo</option>
                            <option value="63">Congo, República Democrática do</option>
                            <option value="142">Coreia do Sul</option>
                            <option value="141">Coreia, República Democrática Popular da</option>
                            <option value="67">Costa do Marfim</option>
                            <option value="73">Costa Rica</option>
                            <option value="120">Croácia</option>
                            <option value="74">Cuba</option>
                            <option value="81">Dinamarca</option>
                            <option value="80">Djibuti</option>
                            <option value="82">Dominica</option>
                            <option value="87">Egipto</option>
                            <option value="227">El Salvador</option>
                            <option value="27">Emirados Árabes Unidos</option>
                            <option value="85">Equador</option>
                            <option value="89">Eritreia</option>
                            <option value="220">Eslováquia</option>
                            <option value="218">Eslovénia</option>
                            <option value="90">Espanha</option>
                            <option value="249">Estados Unidos</option>
                            <option value="86">Estónia</option>
                            <option value="91">Etiópia</option>
                            <option value="93">Fiji</option>
                            <option value="196">Filipinas</option>
                            <option value="92">Finlândia</option>
                            <option value="97">França</option>
                            <option value="99">Gabão</option>
                            <option value="107">Gâmbia</option>
                            <option value="104">Gana</option>
                            <option value="102">Georgia</option>
                            <option value="112">Georgia do Sul e Ilha Sandwich do Sul</option>
                            <option value="105">Gibraltar</option>
                            <option value="101">Granada</option>
                            <option value="111">Grécia</option>
                            <option value="106">Gronelândia</option>
                            <option value="109">Guadalupe</option>
                            <option value="114">Guam</option>
                            <option value="113">Guatemala</option>
                            <option value="116">Guiana</option>
                            <option value="103">Guiana Francesa</option>
                            <option value="108">Guiné</option>
                            <option value="110">Guiné Equatorial</option>
                            <option value="115">Guiné-Bissau</option>
                            <option value="121">Haiti</option>
                            <option value="185">Holanda</option>
                            <option value="119">Honduras</option>
                            <option value="117">Hong Kong</option>
                            <option value="122">Hungria</option>
                            <option value="261">Iémen</option>
                            <option value="57">Ilha Bouvet</option>
                            <option value="118">Ilha Heard e Ilha McDonald</option>
                            <option value="76">Ilha Natividad</option>
                            <option value="182">Ilha Norfolk</option>
                            <option value="144">Ilhas Caimão</option>
                            <option value="68">Ilhas Cook</option>
                            <option value="248">Ilhas Exteriores Menores dos Estados Unidos</option>
                            <option value="96">Ilhas Feroe</option>
                            <option value="94">Ilhas Malvinas (Falkland)</option>
                            <option value="168">Ilhas Marianas do Norte</option>
                            <option value="162">Ilhas Marshall</option>
                            <option value="212">Ilhas Salomão</option>
                            <option value="219">Ilhas Svalbard e Jan Mayen</option>
                            <option value="230">Ilhas Turcas e Caicos</option>
                            <option value="255">Ilhas Virgens, Británicas</option>
                            <option value="256">Ilhas Virgens, EE.UU.</option>
                            <option value="126">Índia</option>
                            <option value="123">Indonésia</option>
                            <option value="129">Irão</option>
                            <option value="128">Iraque</option>
                            <option value="124">Irlanda</option>
                            <option value="130">Islândia</option>
                            <option value="62">Islas Cocos (Keeling)</option>
                            <option value="125">Israel</option>
                            <option value="131">Itália</option>
                            <option value="132">Jamaica</option>
                            <option value="134">Japão</option>
                            <option value="133">Jordânia</option>
                            <option value="138">Kiribati</option>
                            <option value="143">Kuwait</option>
                            <option value="146">Laos</option>
                            <option value="152">Lesoto</option>
                            <option value="155">Letónia</option>
                            <option value="147">Líbano</option>
                            <option value="151">Libéria</option>
                            <option value="157">Líbia</option>
                            <option value="149">Liechtenstein</option>
                            <option value="153">Lituânia</option>
                            <option value="154">Luxemburgo</option>
                            <option value="167">Macau</option>
                            <option value="163">Macedónia</option>
                            <option value="161">Madagascar</option>
                            <option value="177">Malásia</option>
                            <option value="175">Malawi</option>
                            <option value="174">Maldivas</option>
                            <option value="164">Mali</option>
                            <option value="172">Malta</option>
                            <option value="158">Marrocos</option>
                            <option value="169">Martinica</option>
                            <option value="173">Maurícias</option>
                            <option value="170">Mauritânia</option>
                            <option value="262">Mayotte</option>
                            <option value="176">México</option>
                            <option value="95">Micronésia (Estados Federados da)</option>
                            <option value="178">Moçambique</option>
                            <option value="160">Moldávia</option>
                            <option value="159">Mónaco</option>
                            <option value="166">Mongólia</option>
                            <option value="171">Montserrat</option>
                            <option value="165">Myanmar</option>
                            <option value="179">Namíbia</option>
                            <option value="188">Nauru</option>
                            <option value="187">Nepal</option>
                            <option value="184">Nicarágua</option>
                            <option value="181">Níger</option>
                            <option value="183">Nigéria</option>
                            <option value="189">Niue</option>
                            <option value="186">Noruega</option>
                            <option value="180">Nova Caledónia</option>
                            <option value="190">Nova Zelândia</option>
                            <option value="266">Obsoleto véase territorio CD</option>
                            <option value="98">Obsoleto véase territorio FR</option>
                            <option value="156">Obsoleto véase territorio LT</option>
                            <option value="191">Omã</option>
                            <option value="204">Palau</option>
                            <option value="192">Panamá</option>
                            <option value="195">Papua Nova Guiné</option>
                            <option value="197">Paquistão</option>
                            <option value="205">Paraguai</option>
                            <option value="193">Perú</option>
                            <option value="200">Pitcairn</option>
                            <option value="194">Polinésia Francesa</option>
                            <option value="198">Polónia</option>
                            <option value="201">Porto Rico</option>
                            <option value="203">Portugal</option>
                            <option value="206">Qatar</option>
                            <option value="135">Quénia</option>
                            <option value="136">Quirguistão</option>
                            <option value="100">Reino Unido</option>
                            <option value="64">República Centroafricana</option>
                            <option value="78">República Checa</option>
                            <option value="83">República Dominicana</option>
                            <option value="207">Reunión</option>
                            <option value="208">Roménia</option>
                            <option value="210">Ruanda</option>
                            <option value="209">Russia</option>
                            <option value="88">Sahara Ocidental</option>
                            <option value="140">Saint Kitts e Nevis</option>
                            <option value="199">Saint Pierre e Miquelon</option>
                            <option value="260">Samoa</option>
                            <option value="37">Samoa Americana</option>
                            <option value="222">San Marino</option>
                            <option value="253">San Vicente e Granadinas</option>
                            <option value="217">Santa Elena</option>
                            <option value="148">Santa Lucía</option>
                            <option value="226">São Tomé e Príncipe</option>
                            <option value="223">Senegal</option>
                            <option value="221">Serra Leoa</option>
                            <option value="263">Sérvia</option>
                            <option value="213">Seychelles</option>
                            <option value="216">Singapura</option>
                            <option value="228">Síria</option>
                            <option value="224">Somália</option>
                            <option value="150">Sri Lanka</option>
                            <option value="214">Sudão</option>
                            <option value="215">Suécia</option>
                            <option value="66">Suíça</option>
                            <option value="225">Suriname</option>
                            <option value="229">Swazilândia</option>
                            <option value="234">Tailândia</option>
                            <option value="244">Taiwán</option>
                            <option value="235">Tajiquistão</option>
                            <option value="245">Tanzânia</option>
                            <option value="127">Territorio Britânico do Oceano Índico</option>
                            <option value="202">Território Palestino, Ocupado</option>
                            <option value="232">Territórios Franceses do Sul</option>
                            <option value="240">Timor Oriental</option>
                            <option value="233">Togo</option>
                            <option value="236">Tokelau</option>
                            <option value="239">Tonga</option>
                            <option value="242">Trinidad e Tobago</option>
                            <option value="238">Tunísia</option>
                            <option value="237">Turquemenistão</option>
                            <option value="241">Turquia</option>
                            <option value="243">Tuvalu</option>
                            <option value="246">Ucrânia</option>
                            <option value="247">Uganda</option>
                            <option value="250">Uruguai</option>
                            <option value="251">Uzbequistão</option>
                            <option value="258">Vanuatu</option>
                            <option value="252">Vaticano</option>
                            <option value="254">Venezuela</option>
                            <option value="257">Vietname</option>
                            <option value="259">Wallis e Futuna</option>
                            <option value="265">Zâmbia</option>
                            <option value="267">Zimbabwe</option>
                        </select>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" rules="required" v-slot="{ classes }" key="qualifications-input">
                    <div class="input-group input-group-qualifications" :class="classes">
                        <select
                            class="form-control custom-select"
                            v-model="qualifications"
                        >
                            <option disabled value="">Escolaridade</option>
                            <option value="26">9º ANO</option>
                            <option value="27">10º ANO</option>
                            <option value="31">11º ANO</option>
                            <option value="28">12º ANO</option>
                            <option value="29">BACHARELATO</option>
                            <option value="20">LICENCIATURA</option>
                            <option value="21">MESTRADO</option>
                        </select>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" rules="required" v-slot="{ classes }" key="portuguese-input">
                    <div class="input-group input-group-portuguese" :class="classes">
                        <select
                            class="form-control custom-select"
                            v-model="portuguese"
                        >
                            <option disabled value="">Fala português?</option>
                            <option value="1">SIM</option>
                            <option value="0">NÃO</option>
                        </select>
                    </div>
                </validation-provider>
                <div class="tw-text-center tw-mt-4 lg:tw-mt-4 lg:tw-mb-5">
                    <button
                        type="submit"
                        class="btn-cta"
                        :disabled="formLoading"
                    >
                        Mais informações sem compromisso
                    </button>
                </div>
            </fieldset>
            <div class="step-indicators tw-flex tw-items-center tw-justify-center tw-gap-1 tw-mb-6 lg:tw-mb-8" v-show="formStep <= 2 && formError !== true">
                <span :class="{'active' : formStep >= 1}"></span>
                <span :class="{'active' : formStep >= 2}"></span>
            </div>
            <div class="tw-text-center tw-px-3 lg:tw-px-12" v-if="formError == true">
                <h2>Lamentamos mas a fluência em português é imprescindível para concluir o curso com êxito.</h2>
            </div>
            <router-link to="/" class="hover:tw-underline">← Escolher outro curso</router-link>
        </form>
    </validation-observer>
</template>

<script>
// Check validations folder for more validations
import '@/validations';
import '@/validations/phone';
import '@/validations/zip';

export default {
    name: 'FormComponent',
    data() {
        return {
            courseList: [],
            courseInfo: [],
            districtList: [],
            citiesList: [],
            zipsList: [],
            selectedCourse: '',
            name: '',
            phone: '',
            email: '',

            age: '',
            district: '',
            city: '',
            zip: '',
            qualifications: '',
            nationality: '',
            portuguese: '',

            formStep: 1,
            formError: false,
            formLoading: false,
            usedClasses: ['.has-error'],
        };
    },
    methods: {
        slugifyCourse(course) {
            return slugify(course).toLowerCase();
        },
        redirectToCourse() {
            this.$router.push({ path: `/${this.selectedCourse}`, query: this.$route.query });
            this.getCourseInfo();
        },
        getCities() {
            axios
                .post('https://a8oq539y2e.execute-api.eu-west-1.amazonaws.com/Prod', {
                    type: 'cities',
                    district: this.district,
                })
                .then((response) => {
                    this.citiesList = JSON.parse(response.data.body);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getZips() {
            if(document.querySelector('.error-label')) {
                document.querySelector('.error-label').classList.add('tw-hidden');
            }
            axios
                .post('https://a8oq539y2e.execute-api.eu-west-1.amazonaws.com/Prod', {
                    type: 'zip',
                    district: this.district,
                    city: this.city,
                })
                .then((response) => {
                    this.zipsList = JSON.parse(response.data.body);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getCourseInfo() {
            axios
                .get(`https://kw-lp-info.s3-eu-west-1.amazonaws.com/master-d/courses/${this.$route.params.course}/info.json`)
                .then((response) => {
                    this.$store.state.courseInfo = response.data;
                    this.selectedCourse = this.slugifyCourse(this.$store.state.courseInfo.humanFriendlyName);
                })
                .catch(() => {
                    this.$router.push('/');
                });
        },
        formSubmit() {
            if (this.formStep < 2) {
                this.formStep += 1;
                this.$refs.formHandler.reset();
                return;
            }

            if (!this.invalid) {
                // eslint-disable-next-line eqeqeq
                if (this.portuguese == 0) {
                    setTimeout(() => {
                        this.formError = true;
                    }, 500);
                    return;
                }
                this.formLoading = true;

                let cmpInfo = {
                    vendor:{
                        consents: [],
                    },
                    tcString: '',
                };

                try{
                    cmpInfo = __tcfapi('getTCData');
                } catch (e) {
                    console.log('No CMP Info');
                }

                const action = `${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/${process.env.VUE_APP_BACKOFFICE_SLUG}`;
                const data = {
                    user_agent: window.navigator.userAgent,
                    pubid: this.pubid,
                    utm_source: this.$route.query.utm_source,
                    utm_campaign: this.$route.query.utm_campaign,
                    utm_medium: this.$route.query.utm_medium,
                    utm_content: this.$route.query.utm_content,
                    utm_term: this.$route.query.utm_term,
                    ua_device: this.$store.state.ua_device,
                    ua_browser: this.$store.state.ua_browser,
                    ua_os: this.$store.state.ua_os,
                    token: this.$store.state.token,

                    name: this.name,
                    phone: this.phone,
                    email: this.email,
                    course: this.$store.state.courseInfo.code,
                    district: this.district,
                    age: this.age,
                    nationality: this.nationality,
                    qualifications: this.qualifications,
                    city: this.city,
                    zip: this.zip,

                    consent: cmpInfo.vendor.consents.hasOwnProperty('702'),
                    tcString: cmpInfo.tcString,
                    mclic: process.env.VUE_APP_MCLIC,
                };

                axios.post(action, data)
                    .then((response) => {
                        this.$store.state.formSuccess = true;
                        this.$store.state.argann = response.data.argann;
                        this.$store.state.altid = response.data.altid;
                        gtag('event', 'conversion', { send_to: 'AW-659927348/hF1tCOu8l74CELTi1roC' });
                    })
                    .catch((error) => {
                        this.formLoading = false;
                        if(error.response.data.errors.city) {
                            //error.response.data.errors.city = 'Localização Inválida';
                            document.querySelector('.error-label').classList.remove('tw-hidden');
                        }
                        this.$refs.formHandler.setErrors(error.response.data.errors);
                    });
            }
        },
    },
    mounted() {
        this.getCourseInfo();
        axios
            .post('https://a8oq539y2e.execute-api.eu-west-1.amazonaws.com/Prod', {
                type: 'district',
            })
            .then((response) => {
                this.districtList = JSON.parse(response.data.body);
            })
            .catch((error) => {
                console.log(error);
            });
    },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';
form {
    width: 100%;
    height: 100%;
    @screen lg {
        max-width: 450px;
        max-height: 770px;
    }



    h2 {
        color: $main_color;
        font-weight: 700;
        font-size: 22px;
        line-height: 26px;
        @screen lg {
            font-size: 24px;
            line-height: 31px;
        }
    }

    br {
        &.mobile {
            display: block;
            visibility: visible;
            @screen lg {
                display: none;
                visibility: hidden;
            }
        }

        &.desktop {
            display: none;
            visibility: hidden;
            @screen lg {
                display: block;
                visibility: visible;
            }
        }
    }

    .step-indicators {
        span {
            display: block;
            margin-right: 3px;
            margin-left: 3px;
            width: 14px;
            height: 14px;
            border: 1px solid #FFF;
            border-radius: 3px;
            background: #FFF;
            transition: opacity .2s ease-in-out;

            &.active {
              border-color: #FF5039;
                background: #FF5039;
            }
        }
    }
}

</style>
